import type { Message } from '@ai-sdk/react';
import type { AiChat } from 'src/@types/ai';
import { addListener } from '../common';

export const onAiChatMessage = addListener<Message>('/chat/ai/message/new');
export const onAiChatUpdate = addListener<AiChat>('/chat/ai/chat');
